<template>
  <div class="ProgramModuleActivity-list-page w-100">
    <basic-subheader>
      <template v-slot:actions>
        <b-dropdown
          id="dropdown-right dropdown-form"
          class="dropdown-form-filter"
          no-caret
          right
        >
          <template #button-content>
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
            </span>
            Bộ lọc
          </template>
          <h6 class="d-flex align-items-center mb-0 p-4">
            <span class="svg-icon mr-3">
              <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
            </span>
            Bộ lọc
          </h6>
          <b-dropdown-divider> </b-dropdown-divider>
          <b-dropdown-form>
            <b-container class="p-0">
              
              <b-row>
                  <b-col cols="3">
                      <basic-input 
                       label= "Code"
                       placeholder="Nhập Code"
                       name="code"
                       :value.sync="filter.code">
                       </basic-input>
                  </b-col>
                  <b-col cols="3">
                      <basic-input 
                       label= "IsActive"
                       placeholder="1: Đang hoạt động, 0: Không hoạt động"
                       name="Trạng thái hoạt động"
                       :value.sync="filter.isActive">
                       </basic-input>
                  </b-col>
                  <b-col cols="3">
                      
                  </b-col>
              </b-row>
              <b-row>
                  <b-col cols="3">
                      
                  </b-col>
                  <b-col cols="3">
                      <basic-input 
                       label= "IsCustom"
                       placeholder="Nhập IsCustom"
                       name="isCustom"
                       :value.sync="filter.isCustom">
                       </basic-input>
                  </b-col>
                  <b-col cols="3">
                      <basic-input 
                       label= "StartAtDay"
                       placeholder="Nhập StartAtDay"
                       name="startAtDay"
                       :value.sync="filter.startAtDay">
                       </basic-input>
                  </b-col>
              </b-row>
              <b-row>
                  <b-col cols="3">
                      <basic-input 
                       label= "Status"
                       placeholder="Nhập Status"
                       name="status"
                       :value.sync="filter.status">
                       </basic-input>
                  </b-col>
              </b-row>
            </b-container>
          </b-dropdown-form>
          <b-dropdown-divider> </b-dropdown-divider>
          <div class="d-flex align-items-center justify-content-lg-end m-0 p-4">
            <b-button
              class="btn ml-2"
              href="#"
              tabindex="0"
              @click="resetRequest"
            >
              <span class="svg-icon">
                <inline-svg
                  src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                />
              </span>
              Reset bộ lọc
            </b-button>
            <b-button
              class="btn ml-2"
              href="#"
              tabindex="0"
              @click="searchRequest"
            >
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
              </span>
              Lọc dữ liệu
            </b-button>
          </div>
        </b-dropdown>
        <b-button
          v-if="isInsertPermission"
          class="btn btn-success ml-2"
          type="button"
          @click="createItem"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
          </span>
          Thêm mới
        </b-button>
        <b-button
          v-if="isInsertPermission"
          class="btn btn-success ml-2"
          type="button"
          @click="importItems"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/upload-cloud.svg" />
          </span>
          Import
        </b-button>
        <modal-import @import-success="loadData(true)" />
      </template>
    </basic-subheader>
    <b-overlay :show="loading">
      <b-container fluid class="ProgramModuleActivity-list-page__body mb-6 mt-6">
        <b-row>
          <b-col>
            <div class="card card-custom gutter-b">
              <div class="card-body mt-0">
                <template-table
                  :column="column"
                  :data="data"
                  :paging="paging"
                  :tableAction="false"
                  :selectAction="false"
                  :searchAction="false"
                  @search="searchRequest"
                  @reset="resetRequest"
                  @sortBy="sortRequest"
                >
                  <template v-slot:body="{ item }">
                    <td style="width: 20px">
                      <action-dropdown
                        :value="item"
                        :show_edit="isUpdatePermission"
                        :show_delete="false"
                        :show_copy="isInsertPermission"
                        :boundary="data.length > 2 ? 'scrollParent' : 'window'"
                        @view="viewItem"
                        @edit="editItem"
                        @copy="copyItem"
                      >
                        <b-dropdown-text
                          v-if="isDeletePermission"
                          tag="div"
                          class="navi-item cursor-pointer"
                        >
                          <a
                            class="navi-link cursor-pointer"
                            @click="deleteItem(item)"
                          >
                            <span
                              class="menu-icon svg-icon svg-icon-sm"
                              :class="
                                item.active ? 'text-danger' : 'text-primary'
                              "
                            >
                              <inline-svg
                                class="svg-icon"
                                src="/media/svg/icons/Neolex/Basic/power.svg"
                              />
                            </span>
                            <span
                              class="success navi-text"
                              :class="
                                item.active ? 'text-danger' : 'text-primary'
                              "
                            >
                              {{ item.active ? 'Inactive' : 'Active' }}
                            </span>
                          </a>
                        </b-dropdown-text>
                      </action-dropdown>
                    </td>
                    <td :class="getPositionClass(item.code)">
                      {{ item.code }}
                    </td>
                    <td :class="getPositionClass(item.isActive)">
                      {{ item.isActive == 1? "Đang hoạt động" : "Đang không hoạt động" }}
                    </td>
                    <td :class="getPositionClass(item.programModuleId)">
                      {{ item.programModuleId }}
                    </td>
                    <td :class="getPositionClass(item.programActivityId)">
                      {{ item.programActivityId }}
                    </td>
                    <td :class="getPositionClass(item.isCustom)">
                      {{ item.isCustom }}
                    </td>
                    <td :class="getPositionClass(item.startAtDay)">
                      {{ item.startAtDay }}
                    </td>
                    <td :class="getPositionClass(item.status)">
                      {{ item.status }}
                    </td>
                        
                  </template>
                </template-table>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import { TAG_TYPE } from '../../../core/plugins/constants';
export default {
  props: {
   
  },
  name: 'ProgramModuleActivityList',
  components: {
    'modal-import': () => import('./components/FormProgramModuleActivityImport.vue'),
  },
  data() {
    return {
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      filter: {        
        Code: null,        
        IsActive: null,        
        ProgramModuleId: null,        
        ProgramActivityId: null,        
        IsCustom: null,        
        StartAtDay: null,        
        Status: null,   
            },
      sort: {
        by: null,
        order: null,
      },
  column: [
      {
        key: '',
        label: '',
        sortable: false,
      },
        {
          key: 'code',
          label: 'Code',
          sortable: false,
        },
        {
          key: 'isActive',
          label: 'IsActive',
          sortable: false,
        },
        {
          key: 'programModuleId',
          label: 'ProgramModuleId',
          sortable: false,
        },
        {
          key: 'programActivityId',
          label: 'ProgramActivityId',
          sortable: false,
        },
        {
          key: 'isCustom',
          label: 'IsCustom',
          sortable: false,
        },
        {
          key: 'startAtDay',
          label: 'StartAtDay',
          sortable: false,
        },
        {
          key: 'status',
          label: 'Status',
          sortable: false,
        },      
          ],
      data: [],
      loading: false,
      selectedItems: [],
    };
  },
  computed: {
    searchParams() {
      const payload = this.removeEmpty({
        code: this.filter.code,
        isActive: this.filter.isActive,
        programModuleId: this.filter.programModuleId,
        programActivityId: this.filter.programActivityId,
        isCustom: this.filter.isCustom,
        startAtDay: this.filter.startAtDay,
        status: this.filter.status,

        page: this.paging.page,
        size: this.paging.pageSize,
      });
      const params = new URLSearchParams();
      for (const property in payload) {
        params.append(property, payload[property]);
      }      
      return params;
    },
  },
  watch: {
    'paging.page'() {
      this.loadData();
    },
    'paging.pageSize'() {
      this.loadData();
    },
  },
  methods: {
    searchRequest() {
      this.loadData();
      document.body.click();
    },
    resetRequest() {
            this.filter.code = null;
            this.filter.isActive = null;
            this.filter.programModuleId = null;
            this.filter.programActivityId = null;
            this.filter.isCustom = null;
            this.filter.startAtDay = null;
            this.filter.status = null;

      this.loadData();
      document.body.click();
    },
    sortRequest(sortData) {
      this.sort = {
        by: sortData.column,
        order: sortData.order,
      };
      this.loadData();
    },
    viewItem(item) {
      this.$router.push({
        name: 'program_module_activity_view',
        params: {
          id: item.id,
        },
      });
    },
    editItem(item) {
      this.$router.push({
        name: 'program_module_activity_edit',
        params: {
          id: item.id,
          form_type: "edit"
        },
      });
    },
    // TODO: Lanh - If want to new sreen for insert
    // createItem() {
    //   this.$router.push({
    //     name: 'program_module_activity_create',
    //   });
    // },
    getPositionClass(value) {
      if (typeof value === 'number' && !isNaN(value)) {
        return 'text-right'; // Number
      } else if (typeof value === 'string') {
        return 'text-left'; // String
      } else if (
        (Object.prototype.toString.call(value) === '[object Date]' &&
          !isNaN(value)) ||
        !isNaN(Date.parse(value))
      ) {
        return 'text-center'; // Date or DateTime
      } else {
        return 'text-right'; // Unidentified
      }
    },
    createItem() {
      this.$router.push({
        name: 'program_module_activity_edit',
        params: {
          form_type: "create"
        },
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        this.veeFields[ref].dirty &&
        this.veeFields[ref].validated
      ) {
        return this.veeFields[ref].valid;
      }
      return null;
    },
    importItems() {
      this.$bvModal.show('modal-import');
    },
    deleteItem(item) {
      let btn = item.active ? 'btn-inactive' : 'btn-active';
      let textStatusB = item.isActive ? 'Inactive' : 'Active';
      let textStatusA = !item.isActive ? 'Inactive' : 'Active';
      this.$swal({
        title: '',
        text: `Bạn có chắc chắn muốn chuyển trạng thái ${textStatusB} thành ${textStatusA} không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Hủy',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: 'Chắc chắn',
            value: true,
            visible: true,
            className: `btn ${btn}`,
            closeModal: true,
          },
        },
      }).then(
        function (result) {
          if (result) {
            // inactive all
            this.changeStatus(item);
          }
        }.bind(this),
      );
    },
    copyItem(item) {
      this.$router.push({
        name: 'program_module_activity_detail',
        params: {
          form_type: "copy",
          id: item.id,
        },
      });
    },
    async changeStatus(item) {
      this.$store.commit('context/setLoading', true);
      // Create a new FormData object
      const formData = new FormData();

      // Append properties of the item object to formData
      Object.keys(item).forEach((key) => {
        if (key == 'isDeleted') {
          formData.append('isDeleted', item.isDeleted ? '0' : '1');
        } else formData.append(key, item[key]);
      });

      // Send the FormData using the PUT method
      const res = await this.$api.put(`/ProgramModuleActivity/${item.id}`, formData);
      const { error } = res;
      if (error) {
        this.$store.commit('context/setLoading', false);
        return this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      }
      this.$toastr.s({
        title: 'Thành công !',
        msg: 'Cập nhật thành công',
      });
      this.$store.commit('context/setLoading', false);
      this.loadData();
    },
    async loadData() {
      try {
        this.$store.commit('context/setLoading', true);
        const { data } = await this.$api.get('ProgramModuleActivity', {
          params: this.searchParams,
        });
        this.data =
          data.items.map((el) => {
            return {
              ...el,
              //position:
              //  el.accountPositionMappings.length &&
              //  el.accountPositionMappings[0].position.name,
              //hospital: this.getDataHospital(
              //  el.accountRule?.accountRuleTagMappings || [],
              //),
            };
          }) || [];
        this.paging.total = data.total;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    getDataHospital(tags) {
      if (!tags || !tags.length) return null;
      const agencies = tags.filter((el) => el.tag.type === TAG_TYPE.AGENCY);
      return agencies.map((el) => el.tag.name).join(', ');
    },
    getStatus(status) {
      if (status) return 'active';
      return 'inactive';
    },
    searchDebounce(value) {
      this.filter.searchText = value;
      this.resetPaging();
    },
    resetPaging() {
      this.paging.page = 1;
      this.loadData();
    },
    getSearchDataPrepare() {
      this.$api
        .get('ProgramModuleActivity/PrepareSearchFormItem')
        // .then(({ data }) => {
        //   const { agencyList, genderList, positionList, statusList } = data;
        //   this.agencies = agencyList;
        //   this.positions = positionList;
        //   this.statuses = statusList;
        //   this.genders = genderList;
        // })
        .catch((error) => {
          this.$toastr.e({
            title: 'Lỗi',
            msg: error,
          });
        });
    },
  },  
  async created() {
    await Promise.all([this.loadData(), this.getSearchDataPrepare()]);
  },
};
</script>
<style lang="scss" scoped>
.status {
  padding: 6px 24px;
  border-radius: 20px;
  color: #fff;
  text-transform: capitalize;
  width: 96px;
  text-align: center;

  &.active {
    background: #21a567;
  }

  &.inactive {
    background: #ff5756;
  }
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cell-overflow {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dropdown-form-filter {
  .dropdown-menu {
    .container {
      width: 850px;
    }
  }
}

.search-input {
  min-width: 220px;
}
</style>
